import { formatGericParsedDataConnectionResource } from "areas/verifications/helpers/generic-parsed-data";
import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const automatedCsv: IIngestionSourceData = {
  displayName: "Automated CSV",
  isEcom: false,
  isAutomated: true,
  parsedDataFormatter: formatGericParsedDataConnectionResource,
  inventoryReminder: {
    text: "Don't forget to adjust in your inventory management system to reflect this Max Retail sale!",
    buttonText: "OK, I will adjust my inventory",
    titleText: "Inventory Reminder"
  },
  listInventory: {
    linkHref: "/addListing",
    icon: Tag
  },
  cannotUpdateListing: {
    text: `To update this item, upload a CSV to your SFTP folder.`,
  },
  listingsSubheader: {
    text: "You're connected to Automated CSV! You can view your listings on this page, but any changes must be made by uploading CSV files through your SFTP folder.",
  }
}

export default automatedCsv